import { Box, Stack, keyframes } from '@ltvco/refresh-lib/theme';

export const DotsLoading = () => {
  const dotAnimation = keyframes`
    0%, 80%, 100% { opacity: 0; transform: scale(0.8); }
    40% { opacity: 1; transform: scale(1); }
  `;

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="center"
      padding={1}
    >
      {[0, 1, 2].map((dot) => (
        <Box
          key={dot}
          sx={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: 'text.primary',
            animation: `${dotAnimation} 1.4s infinite ease-in-out both`,
            animationDelay: `${dot * 0.16}s`,
          }}
        />
      ))}
    </Stack>
  );
};
